<script lang="ts">
  import { onMount } from "svelte";
  import BridgeDialog from "./BridgeDialog.svelte";
  import BridgeBody from "./BridgeBody.svelte";
  import BridgeErrorBody from "./BridgeErrorBody.svelte";
  import { env } from "$env/dynamic/public";

  let loading = true;
  let error = false;
  let errorText: string = "";

  let structure: Array<Object> = [];

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  onMount(() => {
    window.addEventListener("message", handlePostMessage);
  });

  async function handlePostMessage(event: MessageEvent) {
    // Verifiziere die Herkunft der Nachricht
    if (event.data.type === "BRIDGE_CONTENT") {
      loading = true;
      error = false;
      errorText = "";
      let domContent = event.data.domContent;
      let url = event.data.url;
      // console.log("received: " + domContent)
      // text = "xyz"
      let response = await fetch(
        `${env.PUBLIC_API_GATEWAY_URL}/bridge/simplification`,
        {
          method: "POST",
          body: JSON.stringify({ url, dom: domContent }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status == 200) {
        structure = await response.json();
        loading = false;
      } else {
        error = true;
        let errorResponse = await response.json();
        errorText = errorResponse.detail;
        loading = false;
      }
    }
  }
</script>

<div class="max-h-lvh max-w-lvw p-2 bg-transparent">
  <div
    class="bg-white rounded-lg h-full w-full p-3 flex flex-col gap-2 shadow-lg"
  >
    <BridgeDialog bind:loading>
      {#if !error}
        <BridgeBody {structure} />
      {:else}
        <BridgeErrorBody {errorText} />
      {/if}
    </BridgeDialog>
  </div>
</div>

<style>
  * {
    font-size: 14px; /* Font Size Footer */
  }

  :global(body) {
    background: transparent;
  }

  :global(ul, ol) {
    list-style-type: unset;
    padding-left: 40px;
  }

  :global(html) {
    background: none !important;
  }
</style>
